/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
import { createSlice } from '@reduxjs/toolkit';
import appConfig from '@shared/config';
import { IApp } from '@models/App/App.model';

const STATE_APP = {
  data: {
    apiKey: appConfig.APP_KEY,
  } as IApp,
};

/**
 * Reducer
 */
export const AppState = createSlice({
  name: 'app',
  initialState: STATE_APP,
  reducers: {
    setApiKey: (state, action) => {
      state.data.apiKey = action.payload;
    },
  },
});

/**
 * Selectors
 */
export const get = (state: { app: typeof STATE_APP }) => state.app;
export const getApiKey = state => state.groups.data?.apiKey as string;
export const getLoading = state => state.groups.data?.loading as boolean;

export const { setApiKey } = AppState.actions;
export default AppState.reducer;
